import React, { useEffect, useState } from 'react';
import { Table, Input, Button, Space, DatePicker, Form } from 'antd';
import dayjs from 'dayjs';
import { supabase } from '../../supabaseClient';

const UserAssetList: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [filtering, setFiltering] = useState(false);
  const [dateRange, setDateRange] = useState<[string, string] | null>(null);

  // 查询和筛选
  const fetchAssets = async (filters?: any) => {
    setLoading(true);
    let query = supabase.from('u_user_assets').select('*').order('created_at', { ascending: false });
    if (filters) {
      if (filters.user_id) query = query.eq('user_id', filters.user_id);
      if (filters.start && filters.end) query = query.gte('created_at', filters.start).lte('created_at', filters.end);
    }
    const { data: assets } = await query;
    if (!assets || assets.length === 0) {
      setData([]);
      setLoading(false);
      return;
    }
    // 批量查邮箱
    const userIds = assets.map((item: any) => item.user_id);
    let emailFilter = filters && filters.email ? filters.email : null;
    let profileQuery = supabase.from('u_profiles').select('user_id, email').in('user_id', userIds);
    if (emailFilter) profileQuery = profileQuery.ilike('email', `%${emailFilter}%`);
    const { data: profiles } = await profileQuery;
    const emailMap = new Map((profiles || []).map((p: any) => [p.user_id, p.email]));
    const dataWithEmail = assets.map((item: any) => ({
      ...item,
      email: emailMap.get(item.user_id) || '',
    }));
    setData(dataWithEmail);
    setLoading(false);
  };

  const handleFilter = async () => {
    setFiltering(true);
    const values = await form.validateFields();
    let start = dateRange && dateRange[0] ? dateRange[0] : undefined;
    let end = dateRange && dateRange[1] ? dateRange[1] : undefined;
    await fetchAssets({
      user_id: values.user_id || undefined,
      email: values.email || undefined,
      start,
      end,
    });
    setFiltering(false);
  };

  useEffect(() => {
    fetchAssets();
  }, []);

  const columns = [
    { title: '创建时间', dataIndex: 'created_at', key: 'created_at', width: 150, ellipsis: true, render: (text: string) => text ? new Date(text).toLocaleString('zh-CN', { hour12: false }) : '' },
    { title: '单位', dataIndex: 'token_symbol', key: 'token_symbol', width: 80, ellipsis: true },
    { title: '用户ID', dataIndex: 'user_id', key: 'user_id', width: 300, ellipsis: true },
    { title: '用户邮箱', dataIndex: 'email', key: 'email', width: 220, ellipsis: true },
    { title: '总额', dataIndex: 'total_amount', key: 'total_amount', width: 100, ellipsis: true },
    { title: '可用', dataIndex: 'available_amount', key: 'available_amount', width: 100, ellipsis: true },
    { title: '锁定', dataIndex: 'locked_amount', key: 'locked_amount', width: 100, ellipsis: true },
  ];

  return (
    <div style={{ overflowX: 'auto', background: '#fff', padding: 12 }}>
      <Form form={form} layout="inline" style={{ marginBottom: 16, flexWrap: 'wrap' }}>
        <Form.Item name="user_id">
          <Input placeholder="用户ID" allowClear style={{ width: 180 }} />
        </Form.Item>
        <Form.Item name="email">
          <Input placeholder="用户邮箱" allowClear style={{ width: 180 }} />
        </Form.Item>
        <Form.Item name="created_at" style={{ marginBottom: 8 }}>
          <DatePicker.RangePicker
            style={{ width: 320 }}
            placeholder={['开始时间', '结束时间']}
            value={dateRange ? [dayjs(dateRange[0]), dayjs(dateRange[1])] : null}
            onChange={dates => setDateRange(dates && dates[0] && dates[1] ? [dates[0].toISOString(), dates[1].toISOString()] : null)}
            allowClear
            showTime={false}
          />
        </Form.Item>
        <Button type="primary" onClick={handleFilter} loading={filtering}>筛选</Button>
        <Button style={{ marginLeft: 8 }} onClick={() => { form.resetFields(); setDateRange(null); fetchAssets(); }}>重置</Button>
      </Form>
      <Table
        rowKey="uuid"
        columns={columns}
        dataSource={data}
        loading={loading}
        bordered
        pagination={{ pageSize: 15, showSizeChanger: false, showTotal: (total) => `共 ${total} 条数据`, position: ['bottomRight'] }}
        scroll={{ x: 1200 }}
        size="small"
        style={{ minWidth: 800 }}
        tableLayout="fixed"
      />
    </div>
  );
};

export default UserAssetList;
